export default __webpack_public_path__ + "static/media/table_mockup_fill_4_seats.af0337ce.png";